var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyllabus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_23974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 9H9C7.9 9 7 9.9 7 11V14H9V11H27V25H20V27H27C28.1 27 29 26.1 29 25V11C29 9.9 28.1 9 27 9ZM7 24V27H10C10 25.34 8.66 24 7 24ZM7 20V22C9.76 22 12 24.24 12 27H14C14 23.13 10.87 20 7 20ZM7 16V18C11.97 18 16 22.03 16 27H18C18 20.92 13.07 16 7 16ZM17 17.09V19.09L20.5 21L24 19.09V17.09L20.5 19L17 17.09ZM20.5 12L15 15L20.5 18L26 15L20.5 12Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_23974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabus);
export default __webpack_public_path__ + "static/media/syllabus.addf74b7fd72c9ac9b9d1b9daca7e373.svg";
export { ForwardRef as ReactComponent };